document.addEventListener('DOMContentLoaded', function() {
    // Toggle essential product function
    function toggleSecondCheckbox(inputValue) {
        const selectedBar = document.querySelector('.kaching-bundles__bar--selected');
        if (!selectedBar) return;

        const checkboxes = selectedBar.querySelectorAll('.kaching-bundles__upsell__checkbox');
        if (checkboxes.length <= 1) return;

        const secondCheckbox = checkboxes[1];
        const isSelected = secondCheckbox.classList.contains('kaching-bundles__upsell__checkbox--selected');

        if (inputValue === "essential-time-subscription" && !isSelected) {
            secondCheckbox.click();
        } else if (inputValue !== "essential-time-subscription" && isSelected) {
            secondCheckbox.click();
        }
    }

    // Update Custom subscription prices
    function updateSubscriptionPrices() {
        const selectedBar = document.querySelector(".kaching-bundles__bar--selected");
        if (selectedBar) {
            const priceEl = selectedBar.querySelector('.kaching-bundles__bar-price');
            // const percentageEl = selectedBar.querySelector('.kaching-bundles__bar-label .custom-kaching-save-percentage');

            if (priceEl && priceEl.textContent.trim().length > 0) {
                const barPrice = priceEl.textContent.trim();
                // Update .one_subscription_options .subscription_total
                const subscriptionTotalEl = document.querySelector('.one_subscription_options .subscription_total');
                if (subscriptionTotalEl) {
                    subscriptionTotalEl.textContent = barPrice;
                }

                // Update .essential_subscription_widget .subscription_compare_at_price
                const compareAtPriceEl = document.querySelector('.essential_subscription_widget .subscription_compare_at_price');
                if (compareAtPriceEl) {
                    compareAtPriceEl.textContent = barPrice;
                }

                // Update .essential_subscription_widget .subscription_final_price (30% off)
                const finalPriceEl = document.querySelector('.essential_subscription_widget .subscription_final_price');
                if (finalPriceEl) {
                    const numericPrice = parseFloat(barPrice.replace(/[^0-9.]/g, ""));
                    if (!isNaN(numericPrice)) {
                        const discountedPrice = (numericPrice * 0.7).toFixed(2); // 30% off
                        // Add currency symbol back if exists in barPrice
                        const currencySymbol = barPrice.replace(/[\d.,\s]/g, "");
                        finalPriceEl.textContent = currencySymbol + discountedPrice;
                    }
                }
            }
        }
    }
    
    // Function to update ATC button price
    function updateATCButtonPrice() {
        const checkedSubscription = document.querySelector('.subscription_option input[type="radio"]:checked');
        if (!checkedSubscription) return;

        // Get price from data attribute
        const subscriptionTotalEl = checkedSubscription.closest('.subscription_option').querySelector('[data-subscription-price]');
        const subscriptionPrice = subscriptionTotalEl ? subscriptionTotalEl.textContent.trim() : '';
        // Update the button
        // setTimeout(() => {
        //     const original = document.querySelector('.product-form__btn .show_current_products');

        //     if (original) {
        //         // Remove existing clone if already present
        //         const existingClone = document.querySelector('.product-form__btn .clone_add-to-cart-text');
        //         if (existingClone) existingClone.remove();

        //         // Clone the original element
        //         const clone = original.cloneNode(true);

        //         // Change its class
        //         clone.classList.remove('show_current_products');
        //         clone.classList.add('clone_add-to-cart-text');

        //         // Reset the clone's display so it shows
        //         clone.style.display = "";

        //         // Update the .current_product_total inside clone
        //         const totalEl = clone.querySelector('.current_product_total');
        //         if (totalEl) {
        //             totalEl.textContent = subscriptionPrice;
        //         }

        //         // Append clone into the same parent
        //         original.parentNode.appendChild(clone);

        //         // Hide the original
        //         original.style.display = "none";
        //     }
        // }, 500);

        setTimeout(() => {
            const totalEl = document.querySelector('.product-form__btn .current_product_total');
            if (totalEl) {
                totalEl.textContent = subscriptionPrice;
            }
        }, 100);


        // Update Product Price
        const productOriginalPrice = document.querySelector("product-info .product-price__current-price");
        if (productOriginalPrice) {
            productOriginalPrice.textContent = subscriptionPrice;
        }
        
        // Update 
        const productStickyCart = document.querySelector(".product-form__mobile-sticky-button .current_product_total");
        if (productStickyCart) {
            productStickyCart.textContent = subscriptionPrice;
        }
    }

    const atcObserver = new MutationObserver(() => {
        updateATCButtonPrice();
    });

        const atcTarget = document.querySelector('.product-form__btn');

        if (atcTarget) {
        atcObserver.observe(atcTarget, {
            childList: true,
            subtree: true,
            characterData: true
        });
    }

    function updateProductPrice() {
        // Find the selected bundle
        let selectedBundle = document.querySelector(".kaching-bundles__bar--selected .kaching-bundles__bar-price");
        if (selectedBundle) {
            let price = selectedBundle.textContent.trim();
            // Update the product price element
            let target = document.querySelector(".product-price .product-price__current-price");
            if (target) {
                target.textContent = price;
            }
        }
    }

    const interval = setInterval(() => {
        const bundles = document.querySelectorAll('.kaching-bundles__bar');
        const selectedBar = document.querySelector('.kaching-bundles__bar--selected');
         if (bundles.length > 0) {
            clearInterval(interval);
             // Subscription widget load and trigger 
             if(document.querySelector(".custom_subscription_widget")){
                document.querySelector(".custom_subscription_widget").style.setProperty("display", "flex", "important");
                const oneTimeInput = document.querySelector('.custom_subscription_widget input[data-value="one-time-subscription"]');
                oneTimeInput.click(); 
                // Add is-active class to its closest wrapper
                const oneTimeWrapper = oneTimeInput.closest('.subscription_widget_item');
                oneTimeWrapper.classList.add('is-active');
             }

            // Kaching bundel design: Move price + label into wrapper
            if(document.querySelector(".essentials-bundle-product")){
                bundles.forEach(bar => {
                    const label = bar.querySelector('.kaching-bundles__bar-label');
                    const price = bar.querySelector('.kaching-bundles__bar-price');
                    if (label && price) {
                    // Create wrapper div
                        const wrapper = document.createElement('div');
                        wrapper.classList.add('kaching-save-price-wrapper');

                        // Insert wrapper before price
                        price.parentNode.insertBefore(wrapper, price);

                        // Move price and label into wrapper
                        wrapper.appendChild(price);
                        wrapper.appendChild(label);
                    }
                });
            }
            
            // Update Custom subscription prices
            updateSubscriptionPrices();

            // Update ATC button Price
            updateATCButtonPrice();

            // Show or hide Essentials subscription widget option based on kaching essentials checkbox 
             document.addEventListener("DOMContentLoaded", () => {
            const subscriptionWidget = document.querySelector(".custom_subscription_widget");
            if (!subscriptionWidget) return;

            const updateVisibility = () => {
                const checkboxes = document.querySelectorAll(
                ".kaching-bundles__bar--selected .kaching-bundles__upsell__checkbox"
                );

                subscriptionWidget.style.setProperty(
                "display",
                checkboxes.length > 1 ? "flex" : "none",
                "important"
                );
            };

            // Initial check
            updateVisibility();

            // Observe DOM changes
            const observer = new MutationObserver(updateVisibility);

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
            });
            
            // Handle subscription change
            const subscriptionRadios = document.querySelectorAll('.subscription_option input[type="radio"]');

            subscriptionRadios.forEach(subscriptionRadio => {
                subscriptionRadio.addEventListener('change', function() {
                    if (!this.checked) return;

                    const inputValue = this.getAttribute('data-value');
                    toggleSecondCheckbox(inputValue);

                    // Add class to closest .subscription_widget_item
                    const allWidgetItems = document.querySelectorAll('.subscription_widget_item');
                    allWidgetItems.forEach(item => item.classList.remove('is-active')); // remove from all

                    const closestWidgetItem = this.closest('.subscription_widget_item');
                    if (closestWidgetItem) {
                        closestWidgetItem.classList.add('is-active');
                    }

                    // Update ATC button price on change
                    updateATCButtonPrice();
                });
            });

            // Run again whenever bundle selection changes
            document.querySelectorAll(".essentials-bundle-product .kaching-bundles__bar-container").forEach(container => {
                container.addEventListener("click", () => {
                    setTimeout(() => {
                        //Update Product Price
                        // updateProductPrice();
                        
                        updateSubscriptionPrices();

                        // Also run toggleSecondCheckbox based on currently selected subscription
                        const checkedSubscription = document.querySelector('.subscription_option input[type="radio"]:checked');
                        if (checkedSubscription) {
                            const subscriptionValue = checkedSubscription.getAttribute('data-value');
                            toggleSecondCheckbox(subscriptionValue);
                        }

                        // Update ATC button price on change
                        updateATCButtonPrice();
                    }, 100); 
                });
            });
        }   
    }, 100); // check every 500ms
});
